import { useQuery } from "@tanstack/react-query";
import { IMAGE_KEYS } from "./image.keys";
import { imageServices } from "./image.services";
import { GetImagesParams } from "./image.types";

export const useGetImages = (params?: GetImagesParams) => {
  return useQuery({
    queryKey: IMAGE_KEYS.list(params),
    queryFn: () => imageServices.getImages(params),
  });
};

export const useGetImage = (id?: string) => {
  return useQuery({
    queryKey: IMAGE_KEYS.detail(id!),
    queryFn: () => imageServices.getImage(id!),
    enabled: !!id,
  });
};

export const useGetMyImages = (params?: GetImagesParams) => {
  return useQuery({
    queryKey: IMAGE_KEYS.myImages(params),
    queryFn: () => imageServices.getMyImages(params),
  });
};
